// extracted by css-extract-rspack-plugin
export default {"cls1":"OffsiteAuthorCard-cls1_iuA","cls2":"OffsiteAuthorCard-cls2_k_J OffsiteAuthorCard-cls1_iuA"};